import getSelectionsEntriesExportData from './GetSelectionsEntriesExportData';

const SelectionsEntriesExportData = { getSelectionsEntriesExportData };

export default SelectionsEntriesExportData;